import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Gallery as GalleryService, GalleryItem, ImageItem, VideoItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';

const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg'];

function isVideoUrl(url: string): boolean {
  return VIDEO_EXTENSIONS.some(ext => url.toLowerCase().endsWith(ext));
}

@Component({
  selector: 'app-gallery',
  imports: [],
  templateUrl: './gallery.html',
  styleUrl: './gallery.scss',
})
export class Gallery {

  // Unique id so this gallery's lightbox doesn't collide with other galleries on the page
  private readonly galleryId = 'gallery-lightbox';

  gallerydata: any = environment.GalleryConfig;

  imageData: any[] = this.gallerydata.images;

  isVideo = isVideoUrl;

  selectedIndex = 0;

  constructor(private galleryService: GalleryService, private lightbox: Lightbox) {

    // Create gallery items, using a video item for mp4/webm/ogg sources
    const items: GalleryItem[] = this.imageData.map(item => {
      if (isVideoUrl(item.srcUrl)) {
        return new VideoItem({
          src: [{ url: item.srcUrl, type: 'video/mp4' }],
          thumb: item.previewUrl,
          poster: item.previewUrl,
          controls: true,
        });
      }

      return new ImageItem({
        src: item.srcUrl,
        thumb: item.previewUrl,
        alt: item.alt,
      });
    });

    // 'contain' + disabled autoHeight keeps every image/video fully visible within the fixed lightbox frame
    this.galleryService.ref(this.galleryId, { imageSize: 'contain', thumbPosition: 'bottom', autoHeight: false }).load(items);
  }

  select(index: number): void {
    this.selectedIndex = index;
  }

  prev(): void {
    this.selectedIndex = (this.selectedIndex - 1 + this.imageData.length) % this.imageData.length;
  }

  next(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.imageData.length;
  }

  open(index: number): void {
    this.lightbox.open(index, this.galleryId);
  }

}
